import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=513e8fee&scoped=true&"
import script from "./LocaleSelect.vue?vue&type=script&lang=js&"
export * from "./LocaleSelect.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSelect.vue?vue&type=style&index=0&id=513e8fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e8fee",
  null
  
)

export default component.exports